module.exports = __webpack_public_path__ + "media/img/attch-257a09a6958af76c06b5f230d131c02b.png";